/**
 * Base Adapter Interface
 * All platform-specific adapters must implement this interface
 */

import { ProductData, CartData, OrderData } from '../types';

export abstract class BaseAdapter {
  protected debug: boolean = false;

  constructor(debug: boolean = false) {
    this.debug = debug;
  }

  /**
   * Get adapter name
   */
  abstract getName(): string;

  /**
   * Detect if this platform is present
   */
  abstract detect(): boolean;

  /**
   * Initialize adapter hooks
   */
  abstract init(): void;

  /**
   * Hook into add-to-cart events
   */
  abstract hookAddToCart(callback: (product: ProductData) => void): void;

  /**
   * Hook into product view events
   */
  abstract hookProductView(callback: (product: ProductData) => void): void;

  /**
   * Hook into view cart events
   */
  abstract hookViewCart(callback: (cart?: CartData) => void): void;

  /**
   * Hook into checkout events
   */
  abstract hookCheckout(callback: (cart?: CartData) => void): void;

  /**
   * Hook into purchase events
   */
  abstract hookPurchase(callback: (order: OrderData) => void): void;

  /**
   * Get current cart data
   */
  abstract getCart(): Promise<CartData | null>;

  /**
   * Cleanup and destroy hooks
   */
  destroy(): void {
    if (this.debug) {
    }
  }

  /**
   * Log debug message
   */
  protected log(_message: string, ..._args: any[]): void {
    // Browser console output intentionally removed
  }
}
